import React from 'react';
import { Button } from './ui/button';
import { Bell } from 'lucide-react';

const NotificationBell = ({ user, notifications, unreadCount, showNotifications, setShowNotifications, onMarkAllRead, onLoadNotifications, onNotificationClick }) => {
  if (!(user?.isAdmin || user?.role === 'admin' || user?.role === 'manager')) return null;

  return (
    <div className="relative">
      <Button size="sm" variant="outline" onClick={() => { setShowNotifications(!showNotifications); if (!showNotifications) onLoadNotifications(); }}
        className="border-gray-700 text-gray-300 h-8 w-8 p-0 relative" data-testid="notification-bell">
        <Bell className="h-4 w-4" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full h-4 w-4 flex items-center justify-center font-bold" data-testid="notification-count">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Button>
      {showNotifications && (
        <div className="absolute right-0 top-10 w-80 bg-gray-800 border border-gray-700 rounded-lg shadow-xl z-50 max-h-96 overflow-y-auto" data-testid="notification-dropdown">
          <div className="flex justify-between items-center p-3 border-b border-gray-700">
            <span className="text-white text-sm font-semibold">Bildirimler</span>
            {unreadCount > 0 && (
              <Button size="sm" variant="ghost" onClick={onMarkAllRead}
                className="text-blue-400 text-xs h-6 px-2 hover:text-blue-300" data-testid="mark-all-read-btn">
                Tumunu Oku
              </Button>
            )}
          </div>
          {notifications.length === 0 ? (
            <p className="text-gray-400 text-xs text-center py-4">Bildirim yok</p>
          ) : (
            notifications.map(n => (
              <div key={n.id}
                className={`p-3 border-b border-gray-700/50 cursor-pointer hover:bg-gray-700/50 transition-colors ${!n.read ? 'bg-gray-700/30' : ''}`}
                data-testid={`notification-item-${n.id}`}
                onClick={() => onNotificationClick(n)}>
                <div className="flex items-start gap-2">
                  <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${!n.read ? 'bg-blue-400' : 'bg-gray-600'}`} />
                  <div className="flex-1 min-w-0">
                    <p className="text-white text-xs">{n.message}</p>
                    <p className="text-gray-500 text-[10px] mt-0.5">{new Date(n.createdAt).toLocaleString('tr-TR')}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
